import * as React from 'react';
import { CardContext } from '../card/card-core';
const CardHeaderCore = (props) => {
    const { padding } = React.useContext(CardContext);
    const { background, children, className, } = props;
    const BEM = () => {
        const classArray = ['card__header'];
        const addPaddingClass = (direction, size) => {
            if (size) {
                return classArray.push(`card__header--padding-${direction}-${size}`);
            }
        };
        if (background) {
            classArray.push(`card__header--${background}`);
        }
        if (className) {
            classArray.push(className);
        }
        if (typeof padding === 'string') {
            classArray.push(`card__header--padding-${padding}`);
        }
        else {
            classArray.push('card__header--padding-medium');
            if (padding['right'] === padding['left']) {
                addPaddingClass('horizontal', padding['right']);
            }
            else {
                Object.keys(padding).forEach((key) => {
                    if (key === 'left' || key === 'right') {
                        addPaddingClass(key, padding[key]);
                    }
                });
            }
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM() }, children));
};
export { CardHeaderCore as default, };
